import { render, staticRenderFns } from "./content_layout.vue?vue&type=template&id=9e2ddea8&scoped=true&"
import script from "./content_layout.vue?vue&type=script&lang=js&"
export * from "./content_layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e2ddea8",
  null
  
)

export default component.exports